import React from 'react';
import {Helmet} from "react-helmet";
import {FormattedMessage} from 'react-intl';

export default ({id}) => (<FormattedMessage id={id}>
    {
        (title) => <Helmet><title>{title}</title></Helmet>
    }
</FormattedMessage>);
